import React, { useState, useEffect } from "react";
import { Menu } from "antd";
import { theme } from "../../styles";
import { PlusOutlined } from "@ant-design/icons";

import { Grid, Tabel, DropDown, Button, Typography, Loading } from "../../core";
import AddHsCodeModal from "../../components/Modals/Setting/AddHsCodeModal";
import EditHsCodeModal from "../../components/Modals/Setting/EditHsCodeModal";

import DeleteModals from "../../components/Modals/deleteModals";

import { getAllHsCode, deleteHsCode } from "../../helper/utils/api/settings";

const { colors } = theme;

const btnProps = {
  width: "130px",
  height: "30px",
  bg: colors.pink,
  margin: "10px 0px 10px auto",
};

const typoProps = {
  align: "center",
  as: "h6",
  weight: "600",
  color: "white",
};
const HsCodeCompo = () => {
  const [modalState, setModalState] = useState({
    addHsCodeModal: false,
    editHsCodeModal: false,
    deleteConfirmModal: false,
  });

  const [isLoading, setIsLoading] = useState(false);

  const [record, setRecord] = useState({
    recordToDelete: {},
    recordToEdit: {},
  });

  const [allHsCode, setAllHsCode] = useState([]);

  useEffect(() => {
    getHsCode();
  }, []);

  const hsCodeDeleteHandler = (record) => {
    setModalState((prev) => ({
      ...prev,
      deleteConfirmModal: true,
    }));
    setRecord({
      recordToDelete: record,
      recordToEdit: {},
    });
  };

  const hsCodeEditHandler = (record) => {
    console.log("record", record);

    setModalState((prev) => ({
      ...prev,
      editHsCodeModal: true,
    }));
    setRecord({
      recordToDelete: {},
      recordToEdit: record,
    });
  };

  const getHsCode = async () => {
    let companyId = localStorage.getItem("companyId");
    if (companyId) {
      setIsLoading(true);
      try {
        let {
          data: { result },
        } = await getAllHsCode({ companyId });

        setAllHsCode(result);
      } catch (error) {
        console.log("error from get weave", error);
      }
      setIsLoading(false);
    }
  };

  const openModal = (name) => {
    setModalState((prev) => ({
      ...prev,
      [name]: true,
    }));
  };

  const closeModal = (name) => {
    setModalState((prev) => ({
      ...prev,
      [name]: false,
    }));
  };

  const confirmDeleteHandler = async () => {
    if (record.recordToDelete) {
      let { _id } = record.recordToDelete;
      if (_id) {
        setIsLoading(true);
        try {
          await deleteHsCode(_id);
          closeModal("deleteConfirmModal");
          await getHsCode();
        } catch (error) {}
        setIsLoading(false);
      }
    }
  };

  const menu = (index, record) => {
    return (
      <Menu>
        <Menu.Item onClick={() => hsCodeDeleteHandler(record)}>
          Delete
        </Menu.Item>
        <Menu.Item onClick={() => hsCodeEditHandler(record)}>Edit</Menu.Item>
      </Menu>
    );
  };

  const columns = [
    {
      title: "SR #",
      dataIndex: "SNo",
      key: "S.No",
      width: 150,
      render: (text, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "Hs Code Value",
      dataIndex: "hsCode",
      key: "hsCode",
      width: 150,
    },
    {
      title: "",
      dataIndex: "action",
      width: 150,
      render: (text, record, index) => (
        <DropDown overlay={() => menu(index, record)}></DropDown>
      ),
    },
  ];

  return (
    <Grid>
      {isLoading ? <Loading /> : null}
      <div>
        <Button {...btnProps} onClick={() => openModal("addHsCodeModal")}>
          <Typography {...typoProps} noMargin>
            <PlusOutlined />
            Add Hs Code
          </Typography>
        </Button>
      </div>

      <Tabel columns={columns} data={allHsCode} />

      {modalState.addHsCodeModal && (
        <AddHsCodeModal
          addHsCodeModal={modalState.addHsCodeModal}
          getHsCode={getHsCode}
          closeModal={closeModal}
        />
      )}

      {modalState.deleteConfirmModal && (
        <DeleteModals
          deleteModalsOpen={modalState.deleteConfirmModal}
          closeModal={closeModal}
          confirmDeleteHandler={confirmDeleteHandler}
        />
      )}

      {modalState.editHsCodeModal && (
        <EditHsCodeModal
          editHsCodeModal={modalState.editHsCodeModal}
          closeModal={closeModal}
          getHsCode={getHsCode}
          dataToEdit={record.recordToEdit}
        />
      )}
    </Grid>
  );
};
export default HsCodeCompo;
